export const statesAndCities = {
  "Andhra Pradesh": [
    "Visakhapatnam",
    "Vijayawada",
    "Guntur",
    "Nellore",
    "Kurnool",
    "Tirupati",
    "Rajahmundry",
    "Kakinada",
    "Kadapa",
    "Anantapur",
    "Eluru",
    "Ongole",
    "Nandyal",
    "Machilipatnam",
    "Adoni",
    "Tenali",
    "Chittoor",
    "Hindupur",
    "Proddatur",
    "Bhimavaram",
    "Madanapalle",
    "Guntakal",
    "Dharmavaram",
    "Gudivada",
    "Srikakulam",
    "Narasaraopet",
    "Rajampet",
    "Tadpatri",
    "Tadepalligudem",
    "Chilakaluripet",
  ],
  "Arunachal Pradesh": [
    "Itanagar",
    "Tawang",
    "Pasighat",
    "Ziro",
    "Naharlagun",
    "Bomdila",
    "Tezu",
    "Along",
    "Khonsa",
    "Roing",
    "Daporijo",
    "Aalo",
    "Seppa",
    "Changlang",
    "Yingkiong",
  ],
  "Assam": [
    "Guwahati",
    "Dibrugarh",
    "Silchar",
    "Jorhat",
    "Tezpur",
    "Nagaon",
    "Tinsukia",
    "Bongaigaon",
    "Goalpara",
    "Barpeta",
    "Sivasagar",
    "Karimganj",
    "Dhubri",
    "Diphu",
    "North Lakhimpur",
    "Hailakandi",
    "Mangaldoi",
    "Morigaon",
    "Golaghat",
    "Hojai",
  ],
  "Bihar": [
    "Patna",
    "Gaya",
    "Bhagalpur",
    "Muzaffarpur",
    "Purnia",
    "Darbhanga",
    "Bihar Sharif",
    "Arrah",
    "Katihar",
    "Munger",
    "Chapra",
    "Sasaram",
    "Dehri",
    "Bettiah",
    "Saharsa",
    "Hajipur",
    "Sitamarhi",
    "Samastipur",
    "Begusarai",
    "Motihari",
    "Siwan",
    "Kishanganj",
    "Jamalpur",
    "Jehanabad",
    "Aurangabad",
    "Buxar",
    "Lakhisarai",
    "Nawada",
    "Madhubani",
    "Supaul",
  ],
  "Chhattisgarh": [
    "Raipur",
    "Bhilai",
    "Bilaspur",
    "Korba",
    "Durg",
    "Rajnandgaon",
    "Raigarh",
    "Jagdalpur",
    "Ambikapur",
    "Chirmiri",
    "Dhamtari",
    "Mahasamund",
    "Kanker",
    "Kawardha",
    "Janjgir",
    "Korba",
    "Sakti",
    "Bhatapara",
    "Mungeli",
    "Baloda Bazar",
  ],
  "Goa": [
    "Panaji",
    "Margao",
    "Mapusa",
    "Vasco da Gama",
    "Ponda",
    "Mormugao",
    "Bicholim",
    "Curchorem",
    "Sanquelim",
    "Valpoi",
    "Canacona",
    "Quepem",
    "Sanguem",
    "Pernem",
    "Dharbandora",
  ],
  "Gujarat": [
    "Ahmedabad",
    "Surat",
    "Vadodara",
    "Rajkot",
    "Bhavnagar",
    "Jamnagar",
    "Gandhinagar",
    "Junagadh",
    "Anand",
    "Navsari",
    "Morbi",
    "Nadiad",
    "Surendranagar",
    "Bharuch",
    "Mehsana",
    "Bhuj",
    "Palanpur",
    "Gandhidham",
    "Veraval",
    "Porbandar",
    "Godhra",
    "Botad",
    "Patan",
    "Dahod",
    "Kalol",
    "Himatnagar",
    "Deesa",
    "Amreli",
    "Vapi",
    "Ankleshwar",
  ],
  "Haryana": [
    "Gurugram",
    "Faridabad",
    "Panipat",
    "Ambala",
    "Karnal",
    "Hisar",
    "Sonipat",
    "Rohtak",
    "Yamunanagar",
    "Rewari",
    "Palwal",
    "Bhiwani",
    "Bahadurgarh",
    "Jind",
    "Sirsa",
    "Thanesar",
    "Kaithal",
    "Fatehabad",
    "Gohana",
    "Hansi",
    "Narnaul",
    "Mandi Dabwali",
    "Charkhi Dadri",
    "Shahbad",
    "Pehowa",
    "Samalkha",
    "Pinjore",
    "Ladwa",
    "Safidon",
    "Tohana",
  ],
  "Himachal Pradesh": [
    "Shimla",
    "Manali",
    "Solan",
    "Mandi",
    "Dharamshala",
    "Kullu",
    "Chamba",
    "Palampur",
    "Nahan",
    "Bilaspur",
    "Una",
    "Hamirpur",
    "Kangra",
    "Kasauli",
    "Parwanoo",
    "Sundarnagar",
    "Nalagarh",
    "Rampur",
    "Theog",
    "Jogindernagar",
  ],
  "Jharkhand": [
    "Ranchi",
    "Jamshedpur",
    "Dhanbad",
    "Bokaro",
    "Hazaribagh",
    "Deoghar",
    "Giridih",
    "Ramgarh",
    "Medininagar",
    "Chaibasa",
    "Gumla",
    "Lohardaga",
    "Pakur",
    "Dumka",
    "Jhumri Tilaiya",
    "Phusro",
    "Adityapur",
    "Chatra",
    "Koderma",
    "Jamtara",
  ],
  "Karnataka": [
    "Bengaluru",
    "Mysuru",
    "Mangalore",
    "Hubli",
    "Belagavi",
    "Davangere",
    "Tumakuru",
    "Kalaburagi",
    "Udupi",
    "Bellary",
    "Bijapur",
    "Raichur",
    "Shimoga",
    "Hassan",
    "Bidar",
    "Chitradurga",
    "Gadag",
    "Bagalkot",
    "Mandya",
    "Chikkamagaluru",
    "Kolar",
    "Chamarajanagar",
    "Koppal",
    "Yadgir",
    "Vijayapura",
    "Karwar",
    "Madikeri",
    "Hospet",
    "Gokak",
    "Robertsonpet",
  ],
  "Kerala": [
    "Thiruvananthapuram",
    "Kochi",
    "Kozhikode",
    "Thrissur",
    "Alappuzha",
    "Palakkad",
    "Kollam",
    "Kannur",
    "Kottayam",
    "Malappuram",
    "Manjeri",
    "Thalassery",
    "Pathanamthitta",
    "Kasaragod",
    "Idukki",
    "Wayanad",
    "Attingal",
    "Kayamkulam",
    "Neyyattinkara",
    "Kanhangad",
    "Koyilandy",
    "Nedumangad",
    "Changanassery",
    "Ponnani",
    "Varkala",
    "Paravur",
    "Kunnamkulam",
    "Ottapalam",
    "Perinthalmanna",
    "Mattannur",
  ],
  "Madhya Pradesh": [
    "Bhopal",
    "Indore",
    "Gwalior",
    "Jabalpur",
    "Ujjain",
    "Sagar",
    "Ratlam",
    "Satna",
    "Rewa",
    "Murwara",
    "Singrauli",
    "Burhanpur",
    "Khandwa",
    "Morena",
    "Bhind",
    "Chhindwara",
    "Guna",
    "Shivpuri",
    "Vidisha",
    "Chhatarpur",
    "Damoh",
    "Mandsaur",
    "Khargone",
    "Neemuch",
    "Pithampur",
    "Itarsi",
    "Sehore",
    "Betul",
    "Seoni",
    "Datia",
  ],
  "Maharashtra": [
    "Mumbai",
    "Pune",
    "Nagpur",
    "Nashik",
    "Thane",
    "Aurangabad",
    "Solapur",
    "Kolhapur",
    "Amravati",
    "Nanded",
    "Sangli",
    "Jalgaon",
    "Akola",
    "Latur",
    "Dhule",
    "Ahmednagar",
    "Ichalkaranji",
    "Parbhani",
    "Panvel",
    "Satara",
    "Beed",
    "Yavatmal",
    "Kamptee",
    "Gondia",
    "Barshi",
    "Achalpur",
    "Osmanabad",
    "Nandurbar",
    "Wardha",
    "Udgir",
  ],
  "Manipur": [
    "Imphal",
    "Churachandpur",
    "Thoubal",
    "Ukhrul",
    "Bishnupur",
    "Kakching",
    "Lilong",
    "Mayang Imphal",
    "Yairipok",
    "Wangjing",
    "Moirang",
    "Nambol",
    "Kumbi",
    "Lamka",
    "Moreh",
  ],
  "Meghalaya": [
    "Shillong",
    "Tura",
    "Jowai",
    "Nongpoh",
    "Nongstoin",
    "Baghmara",
    "Williamnagar",
    "Resubelpara",
    "Mairang",
    "Mawkyrwat",
    "Ampati",
    "Khliehriat",
    "Mawphlang",
    "Sohra",
    "Mawlaikynthei",
  ],
  "Mizoram": [
    "Aizawl",
    "Lunglei",
    "Serchhip",
    "Champhai",
    "Kolasib",
    "Lawngtlai",
    "Mamit",
    "Saiha",
    "Saitual",
    "Khawzawl",
    "Hnahthial",
    "Khawbung",
    "Thenzawl",
    "Vairengte",
    "Bilkhawthlir",
  ],
  "Nagaland": [
    "Kohima",
    "Dimapur",
    "Mokokchung",
    "Tuensang",
    "Wokha",
    "Mon",
    "Zunheboto",
    "Phek",
    "Kiphire",
    "Longleng",
    "Peren",
    "Noklak",
    "Chumukedima",
    "Medziphema",
    "Pfutsero",
  ],
  "Odisha": [
    "Bhubaneswar",
    "Cuttack",
    "Rourkela",
    "Sambalpur",
    "Berhampur",
    "Puri",
    "Balasore",
    "Bhadrak",
    "Baripada",
    "Jharsuguda",
    "Bargarh",
    "Rayagada",
    "Jeypore",
    "Paradip",
    "Dhenkanal",
    "Angul",
    "Kendujhar",
    "Balangir",
    "Phulbani",
    "Koraput",
    "Malkangiri",
    "Nabarangpur",
    "Nuapada",
    "Kandhamal",
    "Deogarh",
    "Jagatsinghpur",
    "Kendrapara",
    "Nayagarh",
    "Ganjam",
    "Gajapati",
  ],
  "Punjab": [
    "Ludhiana",
    "Amritsar",
    "Jalandhar",
    "Patiala",
    "Bathinda",
    "Mohali",
    "Hoshiarpur",
    "Batala",
    "Pathankot",
    "Moga",
    "Abohar",
    "Malerkotla",
    "Khanna",
    "Phagwara",
    "Kapurthala",
    "Muktsar",
    "Barnala",
    "Firozpur",
    "Faridkot",
    "Fazilka",
    "Gurdaspur",
    "Rupnagar",
    "Sangrur",
    "Nawanshahr",
    "Tarn Taran",
    "Rajpura",
    "Kotkapura",
    "Zira",
    "Sunam",
    "Malout",
  ],
  "Rajasthan": [
    "Jaipur",
    "Udaipur",
    "Jodhpur",
    "Kota",
    "Ajmer",
    "Bikaner",
    "Alwar",
    "Bhilwara",
    "Ganganagar",
    "Bharatpur",
    "Sikar",
    "Pali",
    "Tonk",
    "Hanumangarh",
    "Beawar",
    "Kishangarh",
    "Jhunjhunu",
    "Baran",
    "Churu",
    "Dausa",
    "Nagaur",
    "Banswara",
    "Dholpur",
    "Jhalawar",
    "Karauli",
    "Sawai Madhopur",
    "Bundi",
    "Baran",
    "Rajsamand",
    "Pratapgarh",
  ],
  "Sikkim": [
    "Gangtok",
    "Namchi",
    "Gyalshing",
    "Mangan",
    "Singtam",
    "Rangpo",
    "Jorethang",
    "Rhenock",
    "Ravangla",
    "Pakyong",
    "Soreng",
    "Melli",
    "Chungthang",
    "Lachen",
    "Lachung",
  ],
  "Tamil Nadu": [
    "Chennai",
    "Coimbatore",
    "Madurai",
    "Salem",
    "Tiruchirappalli",
    "Erode",
    "Vellore",
    "Tirunelveli",
    "Tuticorin",
    "Dindigul",
    "Thanjavur",
    "Kanchipuram",
    "Nagercoil",
    "Karur",
    "Udhagamandalam",
    "Hosur",
    "Neyveli",
    "Cuddalore",
    "Kumbakonam",
    "Tiruvannamalai",
    "Pollachi",
    "Rajapalayam",
    "Sivakasi",
    "Pudukkottai",
    "Vaniyambadi",
    "Gudiyatham",
    "Ambur",
    "Nagapattinam",
    "Karaikudi",
    "Paramakudi",
  ],
  "Telangana": [
    "Hyderabad",
    "Warangal",
    "Nizamabad",
    "Karimnagar",
    "Khammam",
    "Ramagundam",
    "Mahabubnagar",
    "Nalgonda",
    "Adilabad",
    "Siddipet",
    "Suryapet",
    "Miryalaguda",
    "Jagtial",
    "Jangaon",
    "Bodhan",
    "Koratla",
    "Mancherial",
    "Nirmal",
    "Kamareddy",
    "Sangareddy",
    "Medak",
    "Zaheerabad",
    "Narayanpet",
    "Gadwal",
    "Wanaparthy",
    "Nagarkurnool",
    "Yadadri",
    "Bhongir",
    "Jangaon",
    "Gajwel",
  ],
  "Tripura": [
    "Agartala",
    "Udaipur",
    "Dharmanagar",
    "Kailasahar",
    "Belonia",
    "Khowai",
    "Ambassa",
    "Kamalpur",
    "Sabroom",
    "Amarpur",
    "Teliamura",
    "Melaghar",
    "Kumarghat",
    "Sonamura",
    "Bishalgarh",
  ],
  "Uttar Pradesh": [
    "Lucknow",
    "Kanpur",
    "Varanasi",
    "Agra",
    "Noida",
    "Ghaziabad",
    "Meerut",
    "Prayagraj",
    "Bareilly",
    "Aligarh",
    "Moradabad",
    "Saharanpur",
    "Gorakhpur",
    "Faizabad",
    "Firozabad",
    "Jhansi",
    "Muzaffarnagar",
    "Mathura",
    "Rampur",
    "Shahjahanpur",
    "Farrukhabad",
    "Fatehpur",
    "Budaun",
    "Hapur",
    "Etawah",
    "Orai",
    "Sitapur",
    "Bahraich",
    "Unnao",
    "Pilibhit",
  ],
  "Uttarakhand": [
    "Dehradun",
    "Haridwar",
    "Haldwani",
    "Nainital",
    "Rishikesh",
    "Roorkee",
    "Kashipur",
    "Rudrapur",
    "Pithoragarh",
    "Almora",
    "Mussoorie",
    "Kotdwar",
    "Srinagar",
    "Ramnagar",
    "Champawat",
    "Bageshwar",
    "Chamoli",
    "Pauri",
    "Tehri",
    "Uttarkashi",
  ],
  "West Bengal": [
    "Kolkata",
    "Howrah",
    "Siliguri",
    "Durgapur",
    "Asansol",
    "Kharagpur",
    "Bardhaman",
    "Malda",
    "Baharampur",
    "Jalpaiguri",
    "Raiganj",
    "Krishnanagar",
    "Balurghat",
    "Bankura",
    "Chinsurah",
    "Darjeeling",
    "Alipurdar",
    "Purulia",
    "Jangipur",
    "Bishnupur",
    "Cooch Behar",
    "Kalyani",
    "Uluberia",
    "Serampore",
    "Rampurhat",
    "Tamluk",
    "Haldia",
    "Kanchrapara",
    "Habra",
    "Santipur",
  ],

  // Union Territories
  "Andaman and Nicobar Islands": [
    "Port Blair",
    "Diglipur",
    "Mayabunder",
    "Rangat",
    "Hut Bay",
    "Car Nicobar",
    "Kamorta",
    "Nancowry",
    "Katchal",
    "Campbell Bay",
  ],
  "Chandigarh": [
    "Chandigarh",
    "Sector 1",
    "Sector 17",
    "Sector 35",
    "Manimajra",
    "Industrial Area",
  ],
  "Dadra and Nagar Haveli and Daman and Diu": [
    "Daman",
    "Silvassa",
    "Diu",
    "Naroli",
    "Vapi",
    "Masat",
    "Kadaiya",
    "Amli",
    "Khanvel",
    "Dadra",
  ],
  "Delhi": [
    "New Delhi",
    "Central Delhi",
    "North Delhi",
    "South Delhi",
    "East Delhi",
    "West Delhi",
    "North East Delhi",
    "North West Delhi",
    "South West Delhi",
    "Shahdara",
  ],
  "Jammu and Kashmir": [
    "Srinagar",
    "Jammu",
    "Anantnag",
    "Baramulla",
    "Sopore",
    "Kathua",
    "Udhampur",
    "Poonch",
    "Rajouri",
    "Kupwara",
    "Bandipora",
    "Ganderbal",
    "Pulwama",
    "Shopian",
    "Kulgam",
  ],
  "Ladakh": [
    "Leh",
    "Kargil",
    "Drass",
    "Nubra",
    "Zanskar",
    "Nyoma",
    "Diskit",
    "Hemis",
    "Thiksey",
    "Alchi",
  ],
  "Lakshadweep": [
    "Kavaratti",
    "Agatti",
    "Amini",
    "Andrott",
    "Bitra",
    "Chettat",
    "Kadmat",
    "Kalpeni",
    "Kiltan",
    "Minicoy",
  ],
  "Puducherry": [
    "Puducherry",
    "Karaikal",
    "Mahe",
    "Yanam",
    "Ozhukarai",
    "Villianur",
    "Bahour",
    "Nettapakkam",
    "Ariyankuppam",
    "Mannadipet",
  ],
};
